/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_5_DInputs */

const en_cp_cal_5_d = /** @type {(inputs: Cp_Cal_5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder: 10 real users. Solver: test on site with the problem owner.`)
};

const id_cp_cal_5_d = /** @type {(inputs: Cp_Cal_5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder: 10 pengguna nyata. Solver: uji di lokasi pemilik masalah.`)
};

/**
* | output |
* | --- |
* | "Builder: 10 real users. Solver: test on site with the problem owner." |
*
* @param {Cp_Cal_5_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_5_d = /** @type {((inputs?: Cp_Cal_5_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_5_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_5_d(inputs)
	return en_cp_cal_5_d(inputs)
});